// extracted by mini-css-extract-plugin
module.exports = {"footer":"InfluencerFooter-module--footer--2ay7I","title":"InfluencerFooter-module--title--LkmZu","actionBtnContainer":"InfluencerFooter-module--actionBtnContainer--3n2jh"};